import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  data: [],
};

export const consultantStatusSlice = createSlice({
  name: "status",
  initialState,
  reducers: {
    setConsultantStatus: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    updateSingleConsultantStatus: (state, action) => {
      const { _id, onlineStatus } = action.payload;
      const index = state.data.findIndex((item) => item?._id === _id);
      if (index !== -1) {
        state.data[index] = { ...state.data[index], onlineStatus };
      } else {
        state.data.push({ _id, onlineStatus });
      }
    },
  },
});

export const { setConsultantStatus, updateSingleConsultantStatus } = consultantStatusSlice.actions;
export default consultantStatusSlice.reducer;
